<script>
  import Skeleton from '@/lib/components/ui/skeleton/skeleton.svelte';
  import { addDays, format, isToday } from 'date-fns';
  import { Button } from '@/lib/components/ui/button';
  import { formatFriendlyDatePossesive } from '@/Util/utils';

  export let currentDay;
  export let onDateChange;
</script>

<div class="flex flex-col gap-2">
  <div>
    <div class="flex flex-row w-full gap-2 flex-wrap">
      <Button variant="outline" size="sm" class="shrink-0" disabled={isToday(currentDay)} on:click={() => onDateChange(new Date())}>Today</Button>
      <Button variant="ghost" size="sm" class="px-2 shrink-0" on:click={() => onDateChange(addDays(currentDay, -1))}>
        <i class='fa-thin fa-xl fa-chevron-left' aria-hidden='true'/>
      </Button>
      <Button variant="ghost" size="sm" class="px-2 shrink-0" on:click={() => onDateChange(addDays(currentDay, 1))}>
        <i class='fa-thin fa-xl fa-chevron-right' aria-hidden='true'/>
      </Button>
      <h1 class="text-2xl font-semibold m-0 capitalize min-w-0">{formatFriendlyDatePossesive(currentDay)} Activities</h1>
    </div>
  </div>
  {#each { length: 3 } as _, i}
    <Skeleton class="w-full h-[50px]" />
  {/each}
</div>
